import { render, staticRenderFns } from "./Warehousing.vue?vue&type=template&id=67e40f20&scoped=true&"
import script from "./Warehousing.vue?vue&type=script&lang=ts&"
export * from "./Warehousing.vue?vue&type=script&lang=ts&"
import style0 from "./Warehousing.vue?vue&type=style&index=0&id=67e40f20&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e40f20",
  null
  
)

export default component.exports